var _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_72436",
    "data-name": "Group 72436",
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.394,
    height: 156.572,
    viewBox: "0 0 136.394 156.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M19361.824,10031.016V10134.3h123.9v-104.347l-22.955-40.8-78.42-1.912Z",
    transform: "translate(-19356.73 -9984.073)",
    fill: "#f5f5f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M66.238,192.463V95.826H184.276v96.637a4.984,4.984,0,0,1-.611,2.445,4.32,4.32,0,0,1-1.528.306H68.377a4.32,4.32,0,0,1-1.528-.306,4.9,4.9,0,0,1-.611-2.445ZM130.146,57h32.412a22.009,22.009,0,0,0,2.041,3.765c.775,1.288,1.408,2.357,2.128,3.678,1.812,3.307,12.343,20.921,12.638,22.219h-49.23V57Zm-42.2,0h32.718V86.659H71.127l4.147-7.476c1.539-2.554,2.717-4.8,4.234-7.377,1.5-2.554,2.837-4.747,4.256-7.366C84.529,63.032,87.661,58.056,87.944,57ZM57.06,94.309v100.3c0,4.616,5.173,9.789,9.789,9.789H183.664c4.616,0,9.789-5.173,9.789-9.789V93.393c0-2.608-5.031-9.975-6.319-12.332-1.168-2.139-2.357-3.951-3.47-6.013L169.674,51.115c-1.244-1.43-3.689-3.285-6.2-3.285H87.028c-5.151,0-7.628,5.435-9.767,9.189-2.357,4.114-4.693,8.174-7.028,12.234L63.313,81.3c-1.735,2.87-6.253,9.615-6.253,13.019Z",
    transform: "translate(-57.06 -47.83)",
    fill: "#d9d9d9",
    fillRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "_25056c7970f449295eeb08b939ffe33b",
    "data-name": "25056c7970f449295eeb08b939ffe33b",
    d: "M19.029,6A5.029,5.029,0,0,0,14,11.029V36.171a5.029,5.029,0,0,0,10.057,0V11.029A5.029,5.029,0,0,0,19.029,6ZM14,51.257a5.029,5.029,0,1,0,5.029-5.029A5.029,5.029,0,0,0,14,51.257Z",
    transform: "translate(49.063 65.902)",
    fill: "#d9d9d9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDefault);
export default __webpack_public_path__ + "static/media/ProductDefault.10bfe3f0edadb6314943c663ae90a82c.svg";
export { ForwardRef as ReactComponent };